export enum ProfessionsRoute {
  professionList = 'Profession List',
  createProfession = 'Create Profession',
  professionDetails = 'Profession Details',
  createQuestion = 'Create Question',
  editQuestion = 'Edit Question'
}
